import { Box, HStack, Tr, Td, Text, Progress } from '@chakra-ui/react';
import React from 'react';
import { Trans } from '@lingui/react/macro';
import { UserAvatar } from '@duke-hq/ui/components/UserAvatar/UserAvatar';
import { AssignPointsModal } from '../AssignPointsModal';
import type { RouterOutputs } from '@duke-hq/svc-api/provider';

export type CurrentUserRankingRowProps = {
  user: NonNullable<
    RouterOutputs['groupRewards']['listContributorsLeaderboardWithInfiniteScroll']['currentUser']
  >;
};

export const CurrentUserRankingRow: React.FC<CurrentUserRankingRowProps> = React.memo(
  ({ user }) => {
    return (
      <Tr
        position="sticky"
        bottom={0}
        bg="blue.50"
        _hover={{ bg: 'blue.100' }}
        shadow="0 -4px 6px rgba(0, 0, 0, 0.1)"
        borderTop="2px"
        borderBottom="2px"
        borderColor="blue.300"
        zIndex={10}
      >
        <Td width="70px">
          <Box
            width="28px"
            height="28px"
            borderRadius="50%"
            bg="teal.500"
            color="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="xs"
            fontWeight="bold"
          >
            {user.rank}
          </Box>
        </Td>
        <Td>
          <HStack spacing={4}>
            <UserAvatar
              user={{
                first_name: user.firstName ?? '',
                last_name: user.lastName ?? '',
                picture_url: user.pictureUrl,
              }}
              width="32px"
              height="32px"
              boxSize="4"
              fontSize="xs"
            />
            <Text fontSize="sm" fontWeight="semibold" color="blue.700">
              {[user.firstName ?? '', user.lastName ?? ''].filter(Boolean).join(' ')}{' '}
              <Text as="span" fontSize="xs" color="blue.500">
                <Trans>(You)</Trans>
              </Text>
            </Text>
          </HStack>
        </Td>
        <Td>
          <HStack justify="flex-end">
            {user.deletedAt != null ? (
              <AssignPointsModal
                user={{
                  drn: user.userDrn,
                  firstName: user.firstName ?? '',
                  lastName: user.lastName ?? '',
                  pictureUrl: user.pictureUrl ?? null,
                  totalPoints: user.balance ?? 0,
                }}
              />
            ) : (
              <div>&nbsp;</div>
            )}
          </HStack>
        </Td>
        <Td>
          <HStack spacing={3} justify="flex-end">
            <Text fontSize="sm" fontWeight="bold" color="blue.700">
              {user.balance}
            </Text>
          </HStack>
        </Td>
        <Td>
          <HStack spacing={3} justify="flex-end">
            <Text fontSize="sm" color="green.600" fontWeight="bold" minWidth="40px">
              ${user.spent}
            </Text>
            <Progress
              value={user.earned ? (user.spent / user.earned) * 100 : 0}
              size="sm"
              width="100px"
              borderRadius="full"
              colorScheme="blue"
            />
          </HStack>
        </Td>
      </Tr>
    );
  },
);

CurrentUserRankingRow.displayName = 'CurrentUserRankingRow';
